module.exports = __webpack_public_path__ + "img/list_CommIllustration_01.6ebacecb.jpeg";